var React = require('react');

function HamburgerCloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#fff","strokeWidth":"2","d":"M0 1h55M0 53h55M36.2929 37.7071 17.2928 18.707M17.2929 36.2929 36.293 17.2928"}));
}

HamburgerCloseIcon.defaultProps = {"fill":"none","viewBox":"0 0 55 54"};

module.exports = HamburgerCloseIcon;

HamburgerCloseIcon.default = HamburgerCloseIcon;
